export { interceptorWithToken } from './interceptorWithToken';
